(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll("[data-faq]").forEach(item => {
  item.addEventListener("click", () => {
    item.classList.toggle("open");
  });
});

  } catch(e) { console.error(e); }
})();
})();
